<template>
  <b-modal
    v-model="showSplashScreenModal"
    :size="width"
    centered
    hide-footer
    :static="static"
    :lazy="lazy"
    data-test="splash-screen-modal"
  >
    <template v-slot:modal-title>
      <span :style="modalTitleStyle">
        {{ title }}
      </span>
    </template>
    <TTReader
      v-if="splashScreen"
      :config-path="[SPLASH_SCREEN_CONFIG_KEY, 'content']"
      :panel="SPLASH_SCREEN"
      use-primary-store
    />
  </b-modal>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

import TTReader from '@/components/TipTap/wrappers/TTReader.vue'
import { StoryKeys } from '@/types'
import { SPLASH_SCREEN_CONFIG_KEY } from '@/constants'

const components = { TTReader }

const props = {
  static: Boolean,
  lazy: Boolean,
}

@Component({ components })
export default class SplashScreenModal extends Vue.extend({ props }) {
  SPLASH_SCREEN_CONFIG_KEY = SPLASH_SCREEN_CONFIG_KEY
  SPLASH_SCREEN = StoryKeys.SPLASH_SCREEN

  get appLoaded () {
    return this.$typedStore.primary.app.appLoaded
  }

  get showSplashScreenModal () {
    return this.$typedStore.public.display.splashScreen.showModal
  }

  set showSplashScreenModal (newValue) {
    this.$typedStore.public.display.setShowSplashScreen(newValue)
  }

  get splashScreen () {
    return this.$typedStore.primary.app.config.splashScreen
  }

  get title () {
    return this.splashScreen?.title || ''
  }

  get width () {
    return this.splashScreen?.width || 'md'
  }

  get storySettingsPanel () {
    return this.$typedStore.primary.app.config.storySettings.splashscreen
  }

  get headingColor () {
    return this.storySettingsPanel?.headingColor || this.storySettingsPanel?.fontColor
  }

  get modalTitleStyle () {
    return this.appLoaded && this.storySettingsPanel ? {
      'font-family': this.storySettingsPanel.fontFamily,
      color: this.headingColor,
    } : {}
  }
}

</script>
